import React, { FunctionComponent } from 'react';
import { Field } from 'formik';

// MUI
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';

// Common
import { GENERAL } from '../../../../constants';

// Components
import { Tile } from '../../../Tile';
import { FormCheckbox } from '../FormInputs';

// Properties
import * as styles from './FormTerms.styles';

const FormTerms: FunctionComponent = () => {
    return (
        <Tile>
            <Box>
                <Field
                    name="terms"
                    label={GENERAL.TERMS_TERMS}
                    component={FormCheckbox}
                />
                <Field
                    name="emailMarketing"
                    label={GENERAL.TERMS_EMAIL}
                    component={FormCheckbox}
                />
                <Field
                    name="callMarketing"
                    label={GENERAL.TERMS_CALL}
                    component={FormCheckbox}
                />
            </Box>
            <Box>
                <Accordion
                    disableGutters
                    elevation={0}
                    square
                    sx={styles.accordion}
                >
                    <AccordionSummary sx={styles.summary}>
                        <Typography
                            variant="caption"
                        >
                            {GENERAL.TERMS_PERSONAL}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={styles.details}>
                        {GENERAL.TERMS_INFO.map((info, index) => (
                            <Typography
                                key={index}
                                variant="body2"
                                gutterBottom
                                sx={styles.info}
                            >
                                {info}
                            </Typography>
                        ))}
                        <Typography
                            variant="body2"
                            sx={styles.link}
                        >
                            {GENERAL.TERMS_MARK}
                            <Link
                                underline="none"
                                href={`mailto:${GENERAL.TERMS_GWO_EMAIL}`}
                            >
                                {GENERAL.TERMS_GWO_EMAIL}
                            </Link>
                            {GENERAL.TERMS_GWO_DESCRIPTION}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={styles.link}
                        >
                            {GENERAL.TERMS_MARK}
                            <Link
                                underline="none"
                                href={`mailto:${GENERAL.TERMS_IRE_EMAIL}`}
                            >
                                {GENERAL.TERMS_IRE_EMAIL}
                            </Link>
                            {GENERAL.TERMS_IRE_DESCRIPTION}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Box>
            <Box sx={styles.caption}>
                <Typography variant="caption">
                    {GENERAL.REQUIRED}
                </Typography>
            </Box>
            <Box>
                <Divider sx={styles.divider} />
                <Typography variant="caption" sx={styles.description}>
                    {GENERAL.TERMS_ADMINS}
                </Typography>
            </Box>
        </Tile>
    );
};

export default FormTerms;
